import { Col, Input, message, Modal, Row, Select, Typography } from "antd";
import Table, { ColumnsType } from "antd/lib/table";
import { useState } from "react";
import { ProductName } from "shared/components/product/product-name";
import { UpdateDataSuccessfully } from "shared/constants/define-localization";
import { CoreResource, t } from "shared/plugins/localization";
import { createOrderPackingListApi } from "states/order-packing-list/order-packing-list.api";
import { CreatedOrderPackingListModel } from "states/order-packing-list/order-packing-list.models";
import {
  OrderPackingListItemModel,
  OrderPackingListModel,
  OrderShippingConst,
} from "states/order/order.models";

export interface IOrderPackingListModalProps {
  openModal: boolean;
  closeModal: () => void;
  orderPackingListInfo: OrderPackingListModel;
  updateMode: boolean;
  onSuccess: (orderId: string) => Promise<void>;
  onChangeModal: (newModal: IOrderPackingListModalProps) => Promise<void>;
}

export function OrderPackingListModal(props: IOrderPackingListModalProps) {
  const {
    openModal,
    closeModal,
    orderPackingListInfo,
    updateMode,
    onChangeModal,
    onSuccess,
  } = props;
  const [loading, setLoading] = useState(false);

  const handleCreatedPackingList = async () => {
    if (updateMode) {
      closeModal();
      return;
    }
    try {
      setLoading(true);
      let payload = {
        orderPackingListItems: orderPackingListInfo.orderPackingListItems?.map(
          (m) => ({
            orderItemId: m.orderItemId,
          })
        ),
        orderPackingListId: orderPackingListInfo.id,
        billOfLadingCode: orderPackingListInfo.billOfLadingCode,
        collectionAmount: 0,
        customerPayFee: false,
        fee: 0,
        shippingCompanyCode: orderPackingListInfo.shippingCompanyCode,
        pickUpAddressId: undefined,
        shippingOptionId: undefined,
      } as CreatedOrderPackingListModel;
      await createOrderPackingListApi(payload);
      Modal.success({
        title: "Notification",
        content: "Cập nhật thành công",
        afterClose: async () => {
          closeModal();
          await onSuccess(orderPackingListInfo.orderId);
        },
      });
      setLoading(false);
    } catch (err) {
      message.error(
        err?.response?.data?.error?.message ??
          t(CoreResource, "DefaultErrorMessage")
      );
      setLoading(false);
    }
  };

  const orderItemColumns: ColumnsType<OrderPackingListItemModel> = [
    {
      title: "#",
      dataIndex: "stt",
      key: "stt",
      width: "50px",
      render: (stt: string, item, index) => <>{index + 1}</>,
    },
    {
      title: "SKU",
      dataIndex: "skuCode",
      key: "skuCode",
      render: (skuCode: string, item) => item.product.skuCode,
    },
    {
      title: "Tên sản phẩm",
      dataIndex: "name",
      key: "name",
      render: (name: string, item) => <ProductName product={item.product} />,
    },
    {
      title: "Số lượng",
      dataIndex: "shippedQuantity",
      key: "shippedQuantity",
      align: "center",
      render: (shippedQuantity: string, item, index) => shippedQuantity,
    },
  ];

  return (
    <Modal
      title={!updateMode ? `TẠO VẬN ĐƠN` : `THÔNG TIN VẬN ĐƠN`}
      width={1000}
      visible={openModal}
      onOk={() => handleCreatedPackingList()}
      confirmLoading={loading}
      onCancel={closeModal}
    >
      <Row gutter={[16, 16]} justify="space-between" className="mb-4">
        <Col span={24}>
          <Input.Group className="mb-4">
            <Typography.Text>Mã vận đơn: </Typography.Text>
            <Input
              value={orderPackingListInfo?.billOfLadingCode}
              onChange={(e) => {
                onChangeModal({
                  ...props,
                  orderPackingListInfo: {
                    ...orderPackingListInfo,
                    billOfLadingCode: e.target.value,
                  },
                });
              }}
              readOnly={updateMode}
            />
          </Input.Group>
          <Input.Group className="mb-4">
            <Typography.Text>Nhà vận chuyển: </Typography.Text>
            <Select
              className="w-100"
              placeholder="Chọn nhà vận chuyển"
              disabled={updateMode}
              onChange={(value) => {
                onChangeModal({
                  ...props,
                  orderPackingListInfo: {
                    ...orderPackingListInfo,
                    shippingCompanyCode: value,
                  },
                });
              }}
              value={orderPackingListInfo?.shippingCompanyCode}
            >
              <Select.Option value={OrderShippingConst.ShippingCompany.other}>
                Khác
              </Select.Option>
            </Select>
          </Input.Group>

          <div>
            <Typography.Text strong>Địa chỉ:</Typography.Text>
            <div>
              {orderPackingListInfo?.shippingAddress?.street},{" "}
              {orderPackingListInfo?.shippingAddress?.wardName}
              <br />
              {orderPackingListInfo?.shippingAddress?.districtName},{" "}
              {orderPackingListInfo?.shippingAddress?.provinceName}
            </div>
          </div>
        </Col>
        <Col span={24}>
          <Table
            bordered
            columns={orderItemColumns}
            dataSource={[
              ...(orderPackingListInfo?.orderPackingListItems ?? []),
            ]}
            size="small"
            pagination={false}
            scroll={{ y: 300 }}
            className="table-m-0"
          />
        </Col>
      </Row>
    </Modal>
  );
}
